
<div class="container-menu-mobile">
  <nav>
    <ul>
      <li *ngFor="let primary of primaryRouters">
        <a
          [routerLink]="[primary.router]"
          [routerLinkActive]="'active-route'"
        >
          <mat-icon
            class="icon-menu-mobile"
            svgIcon="{{primary.icon}}">
          </mat-icon>
          <p>{{ primary.name }}</p>
        </a>
      </li>
      <li *ngIf="secondaryRouters.length > 0">
        <button
          (click)="toggleOpenMenu()"
        >
          <mat-icon
            class="icon-menu-mobile"
            svgIcon="Mobile Hamburger">
          </mat-icon>
          <p>Mais</p>
        </button>
      </li>
    </ul>
    <div [ngClass]="{'active-menu': open}" *ngIf="secondaryRouters.length > 0" (click)="closeMenu($event)">
      <div>
        <header>
          <button
            (click)="toggleOpenMenu()"
          >
            <mat-icon
              class="icon-menu-toggle"
              svgIcon="Mobile Hamburger">
            </mat-icon>
          </button>
        </header>
        <ul>
          <li *ngFor="let secondary of secondaryRouters">
            <a
              [routerLink]="[secondary.router]"
              [routerLinkActive]="'active-route'"
              (click)="toggleOpenMenu()"
            >
              <mat-icon
                class="icon-menu-mobile"
                svgIcon="{{secondary.icon}}">
              </mat-icon>
              <p>{{ secondary.name }}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
